<div class="login-form-container">
    <span *ngIf="!doShowUserInfo" class="logo_avatar"></span>
    <div *ngIf="doShowLoginForm" class="login-form">
        <div *ngIf="doShowUserInfo">
            <div class="profile-container">
                <span class="profile-img">BH</span>
                <div class="profile-name">
                    <span class="hello-txt">{{helloText}}</span>
                    <span>Tim Cook</span>
                </div>
            </div>
        </div>

        <form #loginForm="ngForm" (ngSubmit)="loginForm.form.valid && login()">

            <h3>{{'Login.lblLoginForm' | translate}}</h3>

            <div *ngIf="!doShowUserInfo" class="field-item form-group user-id">
                <input type="text" #loginID="ngModel" id="userName" name="userName" [(ngModel)]="userName" required autocomplete="nope" autocorrect="off" autocapitalize="off" spellcheck="false" />
                <label for="userName" [ngClass]="{'go-top': userName}">{{'Login.userName' | translate}}</label>
                <span class="errorMessagespan" *ngIf="(loginID.touched || loginForm.submitted) && loginID.errors?.required">
                    {{'Login.userName' | translate}}
                </span>
            </div>
            <div class="field-item form-group user-pass">
                <input [type]="showPassword ? 'text' : 'password'" #loginPass="ngModel" id="userPass" name="userPass" [(ngModel)]="userPass" required />
                <label for="userPass" [ngClass]="{'go-top': userPass}">{{'Login.password' | translate}}</label>
                <span class="errorMessagespan" *ngIf="(loginPass.touched || loginForm.submitted) && loginPass.errors?.required">
                    {{'Login.passwordReq' | translate}}
                </span>
                <div class="pass-action">
                    <span class="eye-icon"  clickable (click)="showPassword = !showPassword"></span>
                    <!--<span class="keypad-icon hidden-xs hidden-sm" [ngClass]="{'on' : showKeyboard}"  clickable (click)="showKeyboard = !showKeyboard"></span>-->
                </div>
            </div>
            <div class="trouble-links"><a href="">{{'Login.lblTroubleLogin' | translate}}</a></div>

            <div style="margin: 10px auto;width: 60%;">
                <div #recaptcha></div>
            </div>

            <div class="login-btn-container form-group">
                <button class="btn-primary" type="submit" name="login" id="login"><span>{{'Login.login' | translate}}</span></button>
                <button *ngIf="!doShowUserInfo" class="btn-secondary" type="button" name="signup" id="signup"><span>{{'Login.signup' | translate}}</span></button>
            </div>

            <div *ngIf="doShowUserInfo" class="trouble-links"><a href="">{{'Login.lblDiffUser' | translate}}</a></div>

        </form>
    </div>
</div>